import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { makeDefaultStylingContext } from '../../../tornado/utils/style';

export const defaultContext = makeDefaultStylingContext();

export const GAP = {
  [HD]: 8,
  [FULL_HD]: 16,
};
